import { useMemo } from "react";
import useFilterOptions from "./useFilterOptions";

export default function useProductNames() {
  const { data: filterOptions, isLoading } = useFilterOptions();

  const productNames = useMemo(() => {
    if (!filterOptions?.common_filters) return [];
    const facet = filterOptions.common_filters.find((f) => f.column_name === "product_molecule");
    return facet?.filter_values ?? [];
  }, [filterOptions]);

  return { productNames, isLoading };
}
